$(document).ready(function () {
    if ($('[data-at-the-airport]').length > 0) {
        $('.widget-zone-area').hide();
        $('.panel-area').hide();

        $('.zone-link').on('click', function () {
            //fix for tablets & mobile to realign columns
            salvattore.rescanMediaQueries();

            var $widgetZoneArea = $(this);
            var widgetZoneAreaId = $widgetZoneArea.attr('widget-zone-area-id');
            var parentPanelArea = $widgetZoneArea.closest('.panel-area');

            $('.main').fadeIn();
            $('.zone-link').not(this).removeClass('active');
            $('.panel-area').not(parentPanelArea).hide();
            $('.widget-zone-area').hide();

            if ($widgetZoneArea.hasClass('active')) {
                $widgetZoneArea.removeClass('active');
                $('widget-zone-area').hide();
                $('.default-widget-zone-area').fadeIn();
                WizardScroll('.default-widget-zone-area', 25);
            }
            else {
                $widgetZoneArea.addClass('active');
                $('.default-widget-zone-area').hide();
                $('#' + widgetZoneAreaId).fadeIn();
                WizardScroll('#' + widgetZoneAreaId, 25);
            }
        });
    }
});